import type { Price } from '@noths/polaris-dev-ts-types';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchDeliveryOptions } from 'src/services/delivery-settings/fetchDeliveryOptions';
import type { DeliverySettingsAPIDeliveryZone } from 'src/services/delivery-settings/types/DeliverySettingsAPIDeliveryZone';

interface RequestDeliveryZoneOptions {
  productCode: number;
  productPrice: Price;
}

export const requestDeliveryZoneOptions = createAsyncThunk<
  DeliverySettingsAPIDeliveryZone[],
  RequestDeliveryZoneOptions,
  { rejectValue: Error }
>(
  'delivery/requestDeliveryZoneOptions',
  async ({ productCode, productPrice }, { rejectWithValue }) => {
    try {
      return await fetchDeliveryOptions(productCode, productPrice);
    } catch (error) {
      const serializableError =
        error instanceof Error
          ? { message: error.message, name: error.name, stack: error.stack }
          : { message: 'Unknown error fetching delivery options', name: 'Error' };

      return rejectWithValue(serializableError);
    }
  },
);
